<script>
import {VerticalCounterCard} from "@/views/statistics/components/index";

export default {
    components: {VerticalCounterCard},
    props: {
        contacted: {
            default() {
                return {data: 0};
            }
        },
        loggedIn: {
            default() {
                return {data: 0};
            }
        },
        openedProductRequest: {
            default() {
                return {data: 0};
            }
        },
        repliedProductRequest: {
            default() {
                return {data: 0};
            }
        }
    },
    data() {
        return {
            counters: []
        };
    },
    methods: {
        initCounters() {
            this.counters = [];
            this.counters.push({
                key: 'counter.supply-chain.suppliers.contacted',
                title: this.$t('Component(Statistics):counter.supply-chain.suppliers.contacted') ,
                avatar: 'ChevronsRightIcon',
                avatarVariant: 'light-primary',
                payment: this.contacted.data,
                deduction: this.contacted.data === 0,
            });
            let percentage = 0;
            if (this.contacted.data > 0) {
                percentage = this.calculatePercentage(
                    this.loggedIn.data,
                    this.contacted.data
                );
            }
            this.counters.push({
                key: 'counter.supply-chain.suppliers.logged-in',
                title: this.$t('Component(Statistics):counter.supply-chain.suppliers.logged-in') ,
                description: percentage + '%',
                avatar: 'CheckIcon',
                avatarVariant: 'light-success',
                payment: this.loggedIn.data,
                deduction: this.loggedIn.data === 0,
            });
            if (this.contacted.data > 0) {
                percentage = this.calculatePercentage(
                    this.openedProductRequest.data,
                    this.contacted.data
                );
            }
            this.counters.push({
                key: 'counter.supply-chain.suppliers.opened-product-request',
                title: this.$t('Component(Statistics):counter.supply-chain.suppliers.opened-product-request'),
                description: percentage + '%',
                avatar: 'CheckIcon',
                avatarVariant: 'light-success',
                payment: this.openedProductRequest.data,
                deduction: this.openedProductRequest.data === 0,
            });
            if (this.contacted.data > 0) {
                percentage = this.calculatePercentage(
                    this.repliedProductRequest.data,
                    this.contacted.data
                );
            }
            this.counters.push({
                key: 'counter.supply-chain.suppliers.replied-product-request',
                title: this.$t('Component(Statistics):counter.supply-chain.suppliers.replied-product-request'),
                description: percentage + '%',
                avatar: 'CheckIcon',
                avatarVariant: 'light-success',
                payment: this.repliedProductRequest.data,
                deduction: this.repliedProductRequest.data === 0,
            });
        },
        calculatePercentage(amount, total) {
            return Math.round(amount / total * 100 * 100) / 100;
        },
    },
    watch: {
        contacted() {
            this.initCounters();
        }
    }
}
</script>

<template>
    <VerticalCounterCard
        :label="$t('Component(Statistics):label-suppliers-counters')"
        :counters="counters"
    />
</template>
